import Vue from "vue";
import Router from "vue-router";
import { mergeTags } from "./metaCommon";

Vue.use(Router);

// root title
const brand = "Abner Simões - Front-end & UX Developer";
// pages
const home = {
  title: brand,
  path: "/",
  description:
    "Me chamo Abner Simões, sou desenvolvedor front-end há dez anos, graduado em design digital e entusiasta em UX.",
};
const about = {
  title: `Sobre | ${brand}`,
  path: "/sobre",
  description:
    "Busco trabalhar sempre com os melhores e mais modernos recursos para desenvolver meus projetos, respeitando padrões de boas práticas e seguindo tendências do mercado.",
};
const projects = {
  title: `Portfólio | ${brand}`,
  path: "/portfolio",
  description:
    "Durante 8 anos de carreira trabalhando como desenvolvedor front-end, muito conhecimento e experiência foi adquirido. Para representar um pouco dessa trajetória separei alguns dos principais projetos que desenvolvi.",
};
const contact = {
  title: `Contato | ${brand}`,
  path: "/contato",
  description:
    "Restou alguma duvida? Mande sua mensagem para trocarmos uma ideia ;)",
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: home.path,
      name: "home",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Home/index.vue"),
      meta: {
        title: home.title,
        metaTags: mergeTags([
          {
            name: "description",
            content: home.description,
          },
          {
            property: "og:description",
            content: home.description,
          },
          {
            property: "og:url",
            content: `${process.env.BASE_URL}${home.path}`,
          },
          {
            property: "og:title",
            content: home.title,
          },
        ]),
      },
    },
    {
      path: about.path,
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About/index.vue"),
      meta: {
        title: about.title,
        metaTags: mergeTags([
          {
            name: "description",
            content: about.description,
          },
          {
            property: "og:description",
            content: about.description,
          },
          {
            property: "og:url",
            content: `${process.env.BASE_URL}${about.path}`,
          },
          {
            property: "og:title",
            content: about.title,
          },
        ]),
      },
    },
    {
      path: projects.path,
      name: "projects",
      component: () =>
        import(/* webpackChunkName: "projects" */ "./views/Projects/index.vue"),
      meta: {
        title: projects.title,
        metaTags: mergeTags([
          {
            name: "description",
            content: projects.description,
          },
          {
            property: "og:description",
            content: projects.description,
          },
          {
            property: "og:url",
            content: `${process.env.BASE_URL}${projects.path}`,
          },
          {
            property: "og:title",
            content: projects.title,
          },
        ]),
      },
    },
    {
      path: contact.path,
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact/index.vue"),
      meta: {
        title: contact.title,
        metaTags: mergeTags([
          {
            name: "description",
            content: contact.description,
          },
          {
            property: "og:description",
            content: contact.description,
          },
          {
            property: "og:url",
            content: `${process.env.BASE_URL}${contact.path}`,
          },
          {
            property: "og:title",
            content: contact.title,
          },
        ]),
      },
    },
    {
      path: "*",
      name: "notFound",
      component: () =>
        import(/* webpackChunkName: "notFound" */ "./views/NotFound/index.vue"),
      meta: {
        title: `Página não encontrada | ${brand}`,
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
